<template>
  <div class="tab">
    <a v-for="tab in tabs" :key="tab.id" :class="{ 'is-current': tab.isCurrent }" @click="scrollToId(tab.id)">
      <p>{{ tab.name }}</p>
    </a>
  </div>
</template>

<script setup lang="ts">
import { gsap } from "gsap"
import { ScrollTrigger } from "gsap/ScrollTrigger"

gsap.registerPlugin(ScrollTrigger)

// アクティブなタブはScrollTriggerで設定されるので、ここでは初期表示だけ
const tabs = [
  {
    id: "introduction",
    name: "概要",
    isCurrent: true,
  },
  {
    id: "feature",
    name: "機能・効果",
    isCurrent: false,
  },
  {
    id: "silhouette",
    name: "形・素材・色",
    isCurrent: false,
  },
  {
    id: "compare",
    name: "商品比較",
    isCurrent: false,
  },
]

const scrollToId = (documentId: string): void => {
  const element = document.getElementById(documentId)
  element?.scrollIntoView({
    behavior: "smooth",
  })
}

onMounted(() => {
  ScrollTrigger.create({
    trigger: "#introduction",
    start: "top center",
    end: "+=99999",
    toggleActions: "play reverse play reverse",
    toggleClass: {
      targets: ".tab",
      className: "active__01",
    },
  })
  ScrollTrigger.create({
    trigger: "#feature",
    start: "top center",
    end: "+=99999",
    toggleActions: "play reverse play reverse",
    toggleClass: {
      targets: ".tab",
      className: "active__02",
    },
  })
  ScrollTrigger.create({
    trigger: "#silhouette",
    start: "top center",
    end: "+=99999",
    toggleActions: "play reverse play reverse",
    toggleClass: {
      targets: ".tab",
      className: "active__03",
    },
  })
  ScrollTrigger.create({
    trigger: "#compare",
    start: "top center",
    end: "+=99999",
    toggleActions: "play reverse play reverse",
    toggleClass: {
      targets: ".tab",
      className: "active__04",
    },
  })
  ScrollTrigger.create({
    trigger: ".section__lineup",
    start: "top center",
    end: "+=99999",
    toggleActions: "play reverse play reverse",
    toggleClass: {
      targets: ".tab",
      className: "active__05",
    },
  })
})

onUnmounted(() => {
  ScrollTrigger.getAll().forEach((trigger) => trigger.kill())
})
</script>

<style scoped lang="scss">
@import "assets/scss/pages/howtochoose_recoverywear_sleepitem/main";
</style>
